module.exports = __webpack_public_path__ + "img/960.4658fc21.svg";